var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUploadError(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "16px",
    height: "16px",
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "00.Icon/ExclamationCircleLine") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u9875\\u9762-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u72B6\\u6001\\u89C4\\u8303",
    transform: "translate(-1045.000000, -1849.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u7F16\\u7EC4-16",
    transform: "translate(1045.000000, 1796.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u7F16\\u7EC4-14",
    transform: "translate(0.000000, 52.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "00.Icon/ExclamationCircleLine",
    transform: "translate(0.000000, 1.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8,0.444444444 C12.1728181,0.444444444 15.5555556,3.82718189 15.5555556,8 C15.5555556,12.1728181 12.1728181,15.5555556 8,15.5555556 C3.82718189,15.5555556 0.444444444,12.1728181 0.444444444,8 C0.444444444,3.82718189 3.82718189,0.444444444 8,0.444444444 Z M8,1.7037037 C4.52265158,1.7037037 1.7037037,4.52265158 1.7037037,8 C1.7037037,11.4773484 4.52265158,14.2962963 8,14.2962963 C11.4773484,14.2962963 14.2962963,11.4773484 14.2962963,8 C14.2962963,4.52265158 11.4773484,1.7037037 8,1.7037037 Z M8,10.5185185 C8.34773484,10.5185185 8.62962963,10.8004133 8.62962963,11.1481481 L8.62962963,11.1481481 L8.62962963,11.462963 C8.62962963,11.8106978 8.34773484,12.0925926 8,12.0925926 C7.65226516,12.0925926 7.37037037,11.8106978 7.37037037,11.462963 L7.37037037,11.462963 L7.37037037,11.1481481 C7.37037037,10.8004133 7.65226516,10.5185185 8,10.5185185 Z M8,3.59259259 C8.34773484,3.59259259 8.62962963,3.87448738 8.62962963,4.22222222 L8.62962963,4.22222222 L8.62962963,9.25925926 C8.62962963,9.6069941 8.34773484,9.88888889 8,9.88888889 C7.65226516,9.88888889 7.37037037,9.6069941 7.37037037,9.25925926 L7.37037037,9.25925926 L7.37037037,4.22222222 C7.37037037,3.87448738 7.65226516,3.59259259 8,3.59259259 Z",
    id: "\\u5F62\\u72B6\\u7ED3\\u5408",
    fill: "#FF3812",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("g", {
    id: "\\u5206\\u7EC4",
    transform: "translate(7.666667, 4.000000)"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadError);
export default __webpack_public_path__ + "static/media/upload_error.8287c841.svg";
export { ForwardRef as ReactComponent };